export default __webpack_public_path__ + "static/media/cloud-computing.23f71d32.svg";